import { GetMainSectionFn } from '../custom-topic-routes'
import { billboardLeaderboardMrec } from 'thewest/routes/ad-units'

export const getEntertainmentRouteInfo: GetMainSectionFn = sectionBuilder => {
    return [
        ...sectionBuilder.getCuratedSection(),
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Celebrity Gossip',
                    headingUrl: '/entertainment/celebrity-gossip',
                    section: 'entertainment',
                },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['entertainment/celebrity-gossip'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Movies',
                    headingUrl: '/entertainment/movies',
                    section: 'entertainment',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['entertainment/movies'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        ...billboardLeaderboardMrec('one'),
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'TV',
                    headingUrl: '/entertainment/tv',
                    section: 'entertainment',
                },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['entertainment/tv'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Music',
                    headingUrl: '/entertainment/music',
                    section: 'entertainment',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['entertainment/music'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        ...billboardLeaderboardMrec('two'),
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Theatre',
                    headingUrl: '/entertainment/theatre',
                    section: 'entertainment',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['entertainment/theatre'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Books',
                    headingUrl: '/entertainment/books',
                    section: 'entertainment',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['entertainment/books'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Arts',
                    headingUrl: '/entertainment/art',
                    section: 'entertainment',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['entertainment/art'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Competitions & Puzzles',
                    headingUrl: '/entertainment/competitions',
                    section: 'entertainment',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['entertainment/competitions'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
    ]
}
